import { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { buildControlledAccessHoldingHref } from '@/features/auth/accessRedirect'
import { resolveHoldReason } from '@/features/auth/accessPolicy'
import { SessionLoadingShell } from '@/features/auth/SessionLoadingShell'
import { useAuthSession } from '@/features/auth/useAuthSession'

import { CommandDeckShell } from './CommandDeckShell'
import { getCommandDeckLiveBundle } from './lib/getCommandDeckLiveBundle'

/** Live Command Deck (`/command-deck`) — AuthSessionProvider + Firestore snapshot truth. */
export function CommandDeckLiveRoute() {
  const { status, access, error, uid } = useAuthSession()
  const location = useLocation()

  const { bundle, unlocked } = useMemo(
    () =>
      getCommandDeckLiveBundle(access, {
        uid,
        pathname: location.pathname,
      }),
    [access, location.pathname, uid]
  )

  if (status === 'loading') {
    return <SessionLoadingShell label="Loading Command Deck access…" />
  }

  if (status === 'anonymous') {
    const redirectTo = `${location.pathname}${location.search}${location.hash}`
    const reason = resolveHoldReason('anonymous', access, error)
    return (
      <Navigate
        to={buildControlledAccessHoldingHref({ redirectTo, reason })}
        replace
      />
    )
  }

  return <CommandDeckShell mode="live" bundle={bundle} unlocked={unlocked} />
}
